// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__u4iM8","tooltiptext":"styles_tooltiptext__tdkfD","top":"styles_top__B2FjI","persist":"styles_persist__cDt66"};